import { render, staticRenderFns } from "./MobileSubnavigation.vue?vue&type=template&id=200a8c79&"
import script from "./MobileSubnavigation.vue?vue&type=script&lang=js&"
export * from "./MobileSubnavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCollection: require('/vercel/path0/components/general/IconCollection.vue').default,NavLink: require('/vercel/path0/components/navigation/NavLink.vue').default})
